import React, { useState, useEffect } from "react";
import { useGetAllAnnouncementsForAdmin } from "../../api/queries";
import { AnnouncementI } from "../../types";
import { AnnouncementStatusFilter } from "../../api/types";
import Container from "../../componentLibrary/Container";
import Spinner from "../../componentLibrary/Spinner";
import AnnouncementsList from "./components/AnnouncementsList";
import EditAnnouncementComponent from "./components/EditAnnouncementComponent";
import AddAnnouncementComponent from "./components/AddAnnouncementComponent";

const AnnouncementManagerPage = () => {
  const [announcementData, setAnnouncementData] = useState<
    AnnouncementI | undefined
  >();
  const [isEdit, setIsEdit] = useState(false);
  const [statusFilter, setStatusFilter] =
    useState<AnnouncementStatusFilter>("all");

  // This hook uses showDismissed: "true" - shows ALL announcements
  const {
    data: announcements,
    isError,
    isLoading,
  } = useGetAllAnnouncementsForAdmin(statusFilter);

  useEffect(() => {
    if (announcementData && announcements) {
      const stillExists = announcements.some(
        (ann) => ann._id === announcementData._id,
      );
      if (!stillExists) {
        setAnnouncementData(undefined);
        setIsEdit(false);
      }
    }
  }, [announcements, announcementData]);

  if (isLoading) return <Spinner className="mx-auto" />;
  if (isError || !announcements) return <div>Error loading announcements</div>;

  return (
    <div className="p-2 sm:p-4">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <Container className="lg:col-span-4 self-start max-h-[83vh] overflow-y-auto">
          <AnnouncementsList
            announcements={announcements}
            announcementId={announcementData?._id}
            setAnnouncementData={setAnnouncementData}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
          />
        </Container>
        <div className="lg:col-span-8 flex flex-col h-full space-y-4">
          {announcementData ? (
            <EditAnnouncementComponent
              originalAnnouncementData={announcementData}
              isEdit={isEdit}
              setIsEdit={setIsEdit}
            />
          ) : (
            <AddAnnouncementComponent />
          )}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementManagerPage;
